import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Button, Box, Typography, Container, Alert, List, ListItem, ListItemText, ListItemIcon, Grid } from '@mui/material';
import { InsertDriveFile as FileIcon } from '@mui/icons-material'
import { getWSLog, getFTPLog, getAllAndroidLogs } from '../../api/axios';
import { useTranslation } from 'react-i18next';

const Logs = () => {
    const { t } = useTranslation('global');

    const [wsLog, setwsLog] = useState([]);
    const [ftpLog, setFTPLog] = useState([]);
    const [androidLogs, setAndroidLogs] = useState([]);
    const [deviceIds, setDeviceIds] = useState([]);
    const [filteredAndroidLogs, setFilteredAndroidLogs] = useState([]);

    const [errMsg, setErrMsg] = useState('');
    const [succMsg, setSuccMsg] = useState('');
    const [tabIndex, setTabIndex] = useState(0);

    const fetchWSLog = async () =>{
        const response = await getWSLog(20);
        console.log(response);
        setwsLog(response);
    }
    const fetchFTPLog = async () =>{
        const response = await getFTPLog(20);
        console.log(response);
        setFTPLog(response);
    }
    const fetchAndroidLogs = async () =>{
        const response = await getAllAndroidLogs();
        console.log(response);
        // Sort logs by timestamp (newest first)
        const sortedLogs = [...response].sort((a, b) => 
            new Date(b.timestamp) - new Date(a.timestamp)
        );
        setAndroidLogs(sortedLogs);
        
        // Extract unique device serial numbers from JSON logs
        const ids = [...new Set(sortedLogs.map(log => 
            log.device_id ? log.device_id.toString() : null
        ).filter(Boolean))];
        setDeviceIds(ids);
        
        // Set initial filtered logs (all sorted logs)
        setFilteredAndroidLogs(sortedLogs);
    }

    const handleTabChange = (event, newIndex) => {
        setTabIndex(newIndex);
    };
    
    useEffect(() => {
        fetchWSLog();
        fetchFTPLog();
        fetchAndroidLogs();
    }, []);

    return (
        <Container maxWidth="md" style={{display:"flex", alignItems: "center", justifyContent: "center" }}>
            <Box
                sx={{
                    display: "flex",
                    mt: 4,
                    p: 3,
                    maxHeight: "60vh",
                    width:"70vw",
                    borderRadius: 2,
                    boxShadow: 3,
                    backgroundColor: '#f9f9f9', justifyContent: "center"
                }}
                className="container-update-files"
            >
                <Tabs value={tabIndex} onChange={handleTabChange} centered orientation="vertical" variant="scrollable"
                sx={{
                borderRight: 1,
                borderColor: "divider",
                minWidth: "10vw",
                }}>
                    <Tab label="Web Socket log" />
                    <Tab label="FTP log" />
                    {deviceIds.map((deviceId, index) => (
                        <Tab 
                            key={deviceId} 
                            label={`Android: ${deviceId}`}
                            onClick={() => {
                                setFilteredAndroidLogs(androidLogs
                                    .filter(log => log.device_id === deviceId)
                                    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                                );
                            }}
                        />
                    ))}
                </Tabs>

                <Box sx={{ p: 2, border: "1px solid #ddd", minHeight: "200px", maxHeight: "60vh", overflow:"auto", width: "75%"}}>
                    {tabIndex === 0 ? (
                        wsLog.map((log, i) => (
                            <Typography key={i}>
                                {typeof log === 'string' ? log : JSON.stringify(log)}
                            </Typography>
                        ))
                    ) : tabIndex === 1 ? (
                        ftpLog.map((log, i) => (
                            <Typography key={i}>
                                {typeof log === 'string' ? log : JSON.stringify(log)}
                            </Typography>
                        ))
                    ) : (
                        filteredAndroidLogs.map((log, i) => (
                            <Box key={i} sx={{ mb: 2 }}>
                                <Typography variant="body2">
                                    <strong>ID:</strong> {log.id}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Timestamp:</strong> {log.timestamp}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Type:</strong> {log.log_type}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Card:</strong> {log.card_number}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Result:</strong> {log.validation_result}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Device:</strong> {log.device_id}
                                </Typography>
                                {log.message && (
                                    <Typography variant="body2">
                                        <strong>Message:</strong> {log.message}
                                    </Typography>
                                )}
                            </Box>
                        ))
                    )}
                </Box>
            </Box>
        </Container >
    );
};

export default Logs;
